<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="container-telefones">
          <span class="material-icons icone"> phone_enabled </span>
          <a href="tel:44984052037" class="btn btn-link link-telefone">
            (44) 98405-2037
          </a>
          <!-- <span>/</span>
          <a href="tel:4435253229" class="btn btn-link link-telefone">
            (44) 3525-3229
          </a> -->
        </div>
        <div class="container-email">
          <span class="material-icons icone"> mail </span>
          <a
            href="mailto:fundacao@educere.org.br"
            class="btn btn-link link-email"
          >
            fundacao@educere.org.br
          </a>
        </div>
      </div>
      <div class="div-imagem col-md-6">
        <a routerLink="/"
          ><img src="assets/imagens/logo-branca.png"
        /></a>
        <br />
      </div>
    </div>
    <div class="version">
      {{ packageInfo.version }}
    </div>
  </div>
</footer>
